import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = {
  class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black",
  role: "row"
}
const _hoisted_4 = ["onClick", "rowspan", "colspan"]
const _hoisted_5 = { class: "fs-7" }
const _hoisted_6 = {
  key: 0,
  style: {"padding-top":"0.4rem !important","padding-bottom":"0.4rem !important"}
}
const _hoisted_7 = { class: "odd" }
const _hoisted_8 = {
  colspan: "7",
  class: "dataTables_empty"
}
const _hoisted_9 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-black",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_14 = {
  key: 0,
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<option value=\"30\">30</option><option value=\"50\">50</option><option value=\"75\">75</option><option value=\"100\">100</option><option value=\"50000000\">All</option>", 5)
const _hoisted_20 = [
  _hoisted_15
]
const _hoisted_21 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", {
        class: _normalizeClass([[_ctx.loading && 'overlay overlay-block'], "table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"]),
        id: "kt_customers_table",
        role: "grid"
      }, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
              return (_openBlock(), _createElementBlock("th", {
                key: i,
                onClick: ($event: any) => (
                  _ctx.sort(
                    cell.sortingField ? cell.sortingField : cell.key,
                    cell.sortable
                  )
                ),
                class: _normalizeClass([
                  cell.name && cell.width ? cell.width : 'min-w-80px',
                  cell.sortable !== false && 'sorting',
                  _ctx.tableHeader.length - 1 === i && 'text-center',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}desc` &&
                    'sorting_desc',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}asc` &&
                    'sorting_asc',
                ]),
                tabindex: "0",
                rowspan: _ctx.tableHeader.rowspan || 1,
                colspan: _ctx.tableHeader.colspan || 1,
                style: {"cursor":"pointer","text-align":"center"}
              }, _toDisplayString(cell.name), 11, _hoisted_4))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_5, [
          (_ctx.getItems.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getItems, (item, inx) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: inx,
                  class: "odd",
                  style: {"border-bottom":"1px solid rgb(29 182 140 / 51%)"}
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                      (cell.key == 'sl')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(inx + 1), 1))
                        : (_openBlock(), _createElementBlock("td", {
                            key: 1,
                            class: _normalizeClass({ 'text-left': _ctx.tableHeader.length - 1 === i }),
                            style: _normalizeStyle(['min-width:' + cell.width, {"padding-top":"0.5rem !important","padding-bottom":"0.5rem !important"}])
                          }, [
                            _renderSlot(_ctx.$slots, `cell-${cell.key}`, { row: item }, () => [
                              _createTextVNode(_toDisplayString(item[_ctx.prop]), 1)
                            ])
                          ], 6))
                    ], 64))
                  }), 128))
                ]))
              }), 128))
            : _createCommentVNode("", true),
          _createElementVNode("template", null, [
            _createElementVNode("tr", _hoisted_7, [
              _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.emptyTableText), 1)
            ])
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (_ctx.enableItemsPerPageDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("label", null, [
                _createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args)))
                }, _hoisted_20, 32)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_el_pagination, {
          "current-page": _ctx.pagination.page,
          "onUpdate:current-page": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination.page) = $event)),
          onCurrentChange: _ctx.currentPageChange,
          "page-size": _ctx.pagination.rowsPerPage,
          layout: "prev, pager, next",
          total: _ctx.pagination.total,
          "hide-on-single-page": true,
          background: ""
        }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
      ])
    ])
  ]))
}